import helperDate from '$$dateFormatsHelper';

class TodayMarker {
  #instance = null;

  #marker = null;

  init(instance) {
    this.#instance = instance;
    this.#marker = null;
    this.#instance.customInterval(() => {
      if (this.#instance.config.current_day_marker) {
        this.addMarker();
      }
    }, 600000, { immediate: true });
  }

  addMarker() {
    if (this.#marker) {
      this.#instance.deleteMarker(this.#marker);
    }

    this.#marker = this.#instance.addMarker({
      id: 'gantt_today_marker',
      start_date: new Date(),
      css: 'today',
      text: __('gantt_today'),
      title: this.#instance.date.date_to_str(helperDate.getDateFormatForGanttGrid())(new Date()),
    });
  }

  removeMarker() {
    if (this.#marker) {
      this.#instance.deleteMarker(this.#marker);
    }
  }
}

export default new TodayMarker();
